import React, { Component } from 'react';
import qs from 'qs';
import { withRouter } from 'react-router-dom';
import {Button, Dialog} from '@betareader/design-system';
import AppIcon from '../../components/AppIcon';
import './publicUserProfile.css';
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import moment from 'moment';
import { toast } from 'react-toastify';

import styled from 'styled-components';

import { updateUserProfile, fetchCountryOptions } from '../../modules/user';

// utils
import { uxAnalyticsUtil, authUtil } from '../../utils';
import Avatar from '../../components/avatar/avatar';

import GenreList from '../../components/lists/genreList';
import LanguageList from '../../components/lists/languageList';
import DisplayNameGetter from './userProfileBuilder/fields/displayName';
import YoBGetter from './userProfileBuilder/fields/yob';
import GenderGetter from './userProfileBuilder/fields/gender';
import GenresGetter from './userProfileBuilder/fields/genresGetter';
import LanguagesGetter from './userProfileBuilder/fields/languages';
import BioGetter from './userProfileBuilder/fields/bio';
import PublicProfileReadingPreferences from './publicProfileReadingPreferences';
import PublicProfileStats from './publicProfileStats';
import RoleGetter from './userProfileBuilder/fields/role';
import Country from './userProfileBuilder/fields/country';

import InviteReader from '../readerIndex/inviteReader';
import SocialProfileLinks from '../readers/components/socialProfileLinks';
import SocialProfiles from './userProfileBuilder/fields/socialProfiles';
import ProfilePhotoUpload from './components/profilePhotoUpload';
import BlockUserButton from '../../components/user/blockUserButton';
import UserReviewsModal from '../../components/user/userReviewsModal';

const MainWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 1em;
`;

const CoverContainer = styled.div`
  min-height: 200px;
  height: 200px;
  width: 100%;
  align-items: center;
  display: flex;
  overflow: hidden;
  position: relative;
`;

const AvatarContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProfileContainer = styled.div`
  flex: 1;
  width: 100%;
`;

const EditIcon = <AppIcon name="pencil" aria-hidden="true" style={{marginLeft: 5, opacity: 0.6}} />;

export {splitOffStatValue} from './publicProfileStats';

export class PublicUserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: undefined,
      userData: undefined,
    };
  }

  componentDidMount() {
    const { props } = this;
    const { location } = props.history;
    uxAnalyticsUtil.trackPageView(
      location.pathname + location.hash + location.search
    );
    this.reset();
    this.getUserInfo();
    this.getUserData();
    this.getCountryOptions();
    const queryObject = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    if (queryObject.show) {
      this.setState({ showModal: queryObject.show });
    }
  }

  reset = () => {
    this.setState({
      userInfo: undefined,
      userData: undefined,
    });
  };

  getUserInfo = async () => {
    const { match, t } = this.props;
    const { userId, userProfile } = this.props;
    const matchUserId = match.params.userId;
    if (!matchUserId && !userId && !userProfile) {
      return; // we don't know who to look for
    }
    const idToken = await authUtil.getFreshIdToken();
    this.setState(
      {
        // clear old data and set refreshing to true
        refreshing: true,
        err: undefined,
      },
      async () => {
        // has user ID, go ahead and fetch
        fetch(
          `${process.env.REACT_APP_API_HOST}${
            process.env.REACT_APP_API_PATH
          }/users/${matchUserId || userId || userProfile._id}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'br-token': idToken,
            },
          }
        )
          .then(res => res.json())
          .then(userInfo => {
            if (userInfo.err) {
              return toast.error(t('SomethingWentWrong'));
            }
            // if the user had a profile
            this.setState({ userInfo });
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {
            this.setState({
              refreshing: false,
            });
          });
      }
    );
  };

  getUserData = async () => {
    const { match } = this.props;
    const { userId, userProfile } = this.props;
    const matchUserId = match.params.userId;
    if (!matchUserId && !userId && !userProfile) {
      return; // we don't know who to look for
    }
    const idToken = await authUtil.getFreshIdToken();
    // has user ID, go ahead and fetch
    fetch(
      `${process.env.REACT_APP_API_HOST}${
        process.env.REACT_APP_API_PATH
      }/users/${matchUserId || userId || userProfile._id}/data`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'br-token': idToken,
        },
      }
    )
      .then(res => res.json())
      .then(userData => {
        // if the user had a profile
        this.setState({
          userData,
        });
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.setState({
          refreshing: false,
        });
      });
  };

  getCountryOptions = async () => {
    const { userProfile } = this.props;
    const idToken = await authUtil.getFreshIdToken();

    this.props.fetchCountryOptions(
      idToken,
      (userProfile && userProfile.language) || 'en'
    );
  };

  getJoinDate = () => {
    const { userInfo } = this.state;
    if (
      Date.now() - new Date(userInfo.createdAt).getTime() >
      1000 * 60 * 60 * 24 * 30
    ) {
      // if more than a month ago, return the date
      return moment(userInfo.createdAt).format('L');
    }
    // otherwise return a time ago string
    return moment(userInfo.createdAt).fromNow();
  };

  isEditable = () => {
    const { userProfile } = this.props;
    const { userInfo } = this.state;
    return userProfile && userInfo && userInfo._id === userProfile._id;
  };

  showModal = fieldName => {
    if (!this.isEditable()) {
      // don't open the modal if we're not going to be able to edit it
      return;
    }
    this.setState({
      showModal: fieldName,
    });
  };

  hideModal = () => {
    this.setState({
      showModal: false,
    });
  };

  updateProfile = async data => {
    const { t } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    if (idToken) {
      this.props.updateUserProfile(idToken, { ...data }, success => {
        if (success) {
          // refresh user info if update was successful
          this.getUserInfo();
        } else {
          toast.error(t('SomethingWentWrong'));
        }
        // always close the modal
        this.hideModal();
      });
    }
  };

  handlePhotoUpdate = photoUrl => {
    // Update the local state immediately for better UX
    this.setState(prevState => ({
      userInfo: {
        ...prevState.userInfo,
        photoUrl: photoUrl,
      },
    }));

    // Also refresh the user info to ensure consistency
    this.getUserInfo();
  };

  getGenderLabel = genderKey => {
    const { t } = this.props;
    const genderKeys = {
      m: 'male',
      f: 'female',
      o: 'other',
      na: 'DontWantToShare',
    };
    if (genderKeys[genderKey]) {
      return t(genderKeys[genderKey]);
    }
    return t('NotSpecified');
  };

  handleInviteClick = () => {
    const { userInfo } = this.state;
    this.setState({ showModal: { inviteReader: userInfo } });
  };

  render() {
    const {userInfo, userData, refreshing, showModal} = this.state;
    const {t, countryOptions, userProfile} = this.props;
    if (refreshing) return <div role="status" className="br-profile-loading">{t('Loading')}</div>;
    if (!userInfo || userInfo.err) return null;
    const selectedCountry = countryOptions?.find(country => country.key === userInfo.country);
    const editable = this.isEditable();
    const fieldLabel = (field, label) => editable
      ? <button type="button" className="br-profile-edit-label" onClick={() => this.showModal(field)}>{label}{EditIcon}</button>
      : <span>{label}</span>;
    const field = (fieldName, label, content) => <div className="br-profile-fact" key={fieldName}>
      <dt>{fieldLabel(fieldName, label)}</dt>
      <dd>{content || t('NotSpecified')}</dd>
    </div>;
    const dialogTitles = {
      displayName: 'Name', yob: 'Age', gender: 'Gender', role: 'Role',
      country: 'Country', bio: 'Bio', socialProfiles: 'SocialProfiles',
      genres: 'PreferredGenres', languages: 'PreferredLanguages',
    };
    return (
      <MainWrapper>
        <CoverContainer>
          {userInfo.coverURL && <img className="br-profile-cover" src={userInfo.coverURL} alt="" />}
          <AvatarContainer>
            {editable ? <ProfilePhotoUpload currentPhotoUrl={userInfo.photoUrl}
              onPhotoUpdate={photoUrl => this.handlePhotoUpdate(photoUrl)} size={112} />
              : <Avatar name={userInfo.displayName} src={userInfo.photoUrl} diameter={112} />}
          </AvatarContainer>
        </CoverContainer>
        <ProfileContainer className="br-profile-content">
          <header className="br-profile-header">
            <div className="br-profile-identity">
              {editable
                ? <h1><button type="button" className="br-profile-name-button" onClick={() => this.showModal('displayName')}>{userInfo.displayName}{EditIcon}</button></h1>
                : <h1>{userInfo.displayName}</h1>}
              {userInfo.socialProfiles && <SocialProfileLinks socialProfiles={userInfo.socialProfiles} />}
              {userData?.averageRating && <span className="br-profile-rating"
                title={t('AverageRatingTooltip', {rating: userData.averageRating, count: userData.reviewCount})}>
                ★ {Number(userData.averageRating).toFixed(1)} / 5 ({userData.reviewCount})
              </span>}
            </div>
            <PublicProfileStats joinDate={this.getJoinDate()} userData={userData} t={t} />
            {userProfile?._id !== userInfo._id && <div className="br-profile-actions">
              {userInfo.readerListConsent && <Button variant="secondary" onClick={this.handleInviteClick}>{t('Invite')}</Button>}
              <BlockUserButton userId={userInfo._id} displayName={userInfo.displayName} compact />
            </div>}
            {userProfile?._id === userInfo._id && <div>
              <label className="br-profile-toggle">
                <input type="checkbox" checked={Boolean(userInfo.readerListConsent)}
                  onChange={event => this.updateProfile({readerListConsent: event.target.checked})} />
                {t('AvailableToRead')}
              </label>
              {userInfo.readerListConsent && <p><em>{t('ReaderListConsentInfo')}</em></p>}
            </div>}
          </header>
          <div className="br-profile-columns">
            <section>
              <h2>{t('UserInfo')}</h2>
              <dl>
                {field('yob', t('Age'), userInfo.age)}
                {field('gender', t('Gender'), this.getGenderLabel(userInfo.gender))}
                {field('role', t('Role'), userInfo.roleKey ? t(userInfo.roleKey) : null)}
                {field('country', t('Country'), selectedCountry?.name || userInfo.country)}
              </dl>
              <h2>{fieldLabel('bio', t('Bio'))}</h2>
              <p className="br-profile-bio">{userInfo.bio || t('NotSpecified')}</p>
            </section>
            <section>
              <h2>{fieldLabel('socialProfiles', t('SocialProfiles'))}</h2>
              {userInfo.socialProfiles && Object.values(userInfo.socialProfiles).some(Boolean)
                ? <SocialProfileLinks socialProfiles={userInfo.socialProfiles} />
                : <p>{t('NotSpecified')}</p>}
              <h2>{fieldLabel('genres', t('PreferredGenres'))}</h2>
              <GenreList genres={userInfo.preferredGenres} noInfoMessage={t('NotSpecified')} />
              <h2>{fieldLabel('languages', t('PreferredLanguages'))}</h2>
              <LanguageList languages={userInfo.preferredLanguages} noInfoMessage={t('NotSpecified')} />
              <PublicProfileReadingPreferences editable={editable}
                initialValue={userProfile?.showAiGeneratedManuscripts}
                updating={this.props.updatingUserProfile?.includes('showAiGeneratedManuscripts')}
                onUpdate={async data => {
                  const idToken = await authUtil.getFreshIdToken();
                  this.props.updateUserProfile(idToken, data);
                }} t={t} />
            </section>
          </div>
        </ProfileContainer>
        {showModal === 'review' && userInfo && <UserReviewsModal open onClose={this.hideModal} user={userInfo} />}
        {showModal && showModal !== 'review' && <Dialog open
          title={t(showModal.inviteReader ? 'Invite' : dialogTitles[showModal] || 'Edit')}
          onClose={this.hideModal}
          actions={<Button variant="secondary" onClick={this.hideModal}>{t('Close')}</Button>}>
          {showModal === 'displayName' && <DisplayNameGetter initialValue={userInfo.displayName} onUpdate={this.updateProfile} />}
          {showModal === 'yob' && <YoBGetter initialValue={userInfo.yob} onUpdate={this.updateProfile} />}
          {showModal === 'gender' && <GenderGetter initialValue={userInfo.gender} onUpdate={this.updateProfile} />}
          {showModal === 'genres' && <GenresGetter initialValue={userInfo.preferredGenres}
            onUpdate={value => this.updateProfile({preferredGenres: value})} />}
          {showModal === 'languages' && <LanguagesGetter
            initialValue={userInfo.preferredLanguages?.map(lang => lang.key)}
            onUpdate={value => this.updateProfile({preferredLanguages: value})} />}
          {showModal === 'bio' && <BioGetter initialValue={userInfo.bio} onUpdate={this.updateProfile} />}
          {showModal === 'role' && <RoleGetter initialValue={userInfo.role} onUpdate={this.updateProfile} />}
          {showModal === 'socialProfiles' && <SocialProfiles socialProfiles={userInfo.socialProfiles || {}}
            onChange={socialProfiles => this.updateProfile({socialProfiles})} />}
          {showModal.inviteReader && <InviteReader reader={showModal.inviteReader}
            onClose={() => this.setState({showModal: false})} />}
          {showModal === 'country' && <Country initialValue={userInfo.country} onUpdate={this.updateProfile} />}
        </Dialog>}
      </MainWrapper>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  userProfile: state.user.userProfile,
  countryOptions: state.user.countryOptions,
  updatingUserProfile: state.user.updatingUserProfile,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateUserProfile,
      fetchCountryOptions,
      changePage: newPage => push(newPage),
    },
    dispatch
  );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(PublicUserProfile))
);
